import { render, staticRenderFns } from "./orderAmountSummary.vue?vue&type=template&id=2dbc994f&scoped=true"
import script from "./orderAmountSummary.vue?vue&type=script&lang=js"
export * from "./orderAmountSummary.vue?vue&type=script&lang=js"
import style0 from "./orderAmountSummary.vue?vue&type=style&index=0&id=2dbc994f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc994f",
  null
  
)

export default component.exports